// DS: i3.16
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorDelete: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M15 4a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H4a1 1 0 000 2h1v11.586a1 1 0 00.293.707l1.414 1.414a1 1 0 00.707.293h9.172a1 1 0 00.707-.293l1.414-1.414a1 1 0 00.293-.707V7h1a1 1 0 100-2h-5V4zM7 7h10v11.17l-.83.83H7.829L7 18.171V7zm3 3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm5 1a1 1 0 10-2 0v5a1 1 0 102 0v-5z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
EditorDelete.displayName = 'EditorDelete';

export default EditorDelete;
